<template>
  <div>
    <div class="slide-modal-title">Add a new bike</div>
    <AddEditBike button-text="Add Bike" @submit-bike="add" />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import AddEditBike from '@/components/common/AddEditBike'

export default {
  name: 'BikeAdd',
  components: { AddEditBike },
  methods: {
    ...mapActions('quote', { addBike: 'addBike' }),
    add(bike) {
      this.addBike(bike)
      this.$modal.hide('bike-add')
      if (this.$store.getters['quote/isMta']) {
        this.$router.push({
          path: `/quote/${this.$route.params.policyid}/start-date`,
          query: { ...this.$route.query, type: 'payment', modal: 'bike' },
        })
      }
    },
  },
}
</script>
